module.exports = __webpack_public_path__ + "img/linked-account.e05765e6.jpg";